// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthWrapper_wrapper__NNxeg","formContainer":"AuthWrapper_formContainer__vUFKB"};